import _curry from "ramda/es/curry";
import _view from "ramda/es/view";
import _isEmpty from "ramda/es/isEmpty";
import _pipe from "ramda/es/pipe";

var lensIsEmpty = function (lens, obj) {
  return _pipe(_view(lens), _isEmpty)(obj);
};

export default _curry(lensIsEmpty);